import Vue from "vue";
import Vuex from "vuex";
import { getModule } from "vuex-module-decorators";
import MAlert from "./modules/MAlert";
import MApp from "./modules/MApp";
import MCases from "./modules/MCases";
import MRoles from "./modules/MRoles";
import MDocuments from "./modules/MDocuments";
import MDocumentsV2 from "./modules/MDocumentsV2";
import MHorizontalQuestionnaire from "./modules/MHorizontalQuestionnaire";
import MQuestionnaire from "./modules/MQuestionnaire";
import MTasks from "./modules/MTasks";
import MUser from "./modules/MUser";
import MValidationModal from "./modules/MValidationModal";
import MTasksServices from "./modules/MTasksServices";
import MToaster from "./modules/MToaster";
import MTeammates from "./modules/MTeammates";
import MHotjar from "./modules/MHotjar";
import MNps from "./modules/MNps";
import MNotifications from "./modules/MNotifications";
import MAdditionalInfo from "./modules/MAdditionalInfo";
import MActivityLog from "./modules/MActivityLog";

Vue.use(Vuex);

// eslint-disable-next-line import/no-named-as-default-member
const store = new Vuex.Store({
  modules: {
    MApp,
    MQuestionnaire,
    MHorizontalQuestionnaire,
    MValidationModal,
    MTasks,
    MRoles,
    MDocuments,
    MDocumentsV2,
    MUser,
    MCases,
    MAlert,
    MTasksServices,
    MToaster,
    MTeammates,
    MHotjar,
    MNps,
    MNotifications,
    MAdditionalInfo,
    MActivityLog,
  },
});

export const SMApp = getModule(MApp, store);
export const SMQuestionnaire = getModule(MQuestionnaire, store);
export const SMHorizontalQuestionnaire = getModule(MHorizontalQuestionnaire, store);
export const SMValidationModal = getModule(MValidationModal, store);
export const SMTasks = getModule(MTasks, store);
export const SMRoles = getModule(MRoles, store);
export const SMDocuments = getModule(MDocuments, store);
export const SMDocumentsV2 = getModule(MDocumentsV2, store);
export const SMUser = getModule(MUser, store);
export const SMCases = getModule(MCases, store);
export const SMAlert = getModule(MAlert, store);
export const SMTasksServices = getModule(MTasksServices, store);
export const SMToaster = getModule(MToaster, store);
export const SMTeammates = getModule(MTeammates, store);
export const SMHotjar = getModule(MHotjar, store);
export const SMNps = getModule(MNps, store);
export const SMNotifications = getModule(MNotifications, store);
export const SMAdditionalInfo = getModule(MAdditionalInfo, store);
export const SMActivityLog = getModule(MActivityLog, store);

export default store;
